import React, { useRef, useState } from 'react';
import * as Styled from './textFieldStyle';
import { isNotNull, validateForm } from '../../../utils/validations';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppColors } from '../../../constants';

const TextField = ({
  label,
  type,
  name,
  color,
  required,
  handleTextInput,
  value,
  handleTextError,
  minHeight,
}) => {
  const [translation] = useTranslation();
  const errorStoreData = useSelector((state) => state.ErrorReducer.errorData);
  const getWebData = useSelector((state) => state.websiteDataReducer.stateData);
  const textInput = useRef(null);
  const [field, setField] = useState(value || '');
  const [errorMessage, setErrorMessage] = useState('');
  const updateErrorMessage = (value) => {
    setErrorMessage(value);
  };
  const inputColor =
    required && getWebData.isSubmitted && !isNotNull(field)
      ? AppColors.Red
      : required &&
        getWebData.isSubmitted &&
        (errorStoreData[name] !== '' || errorStoreData[name] === undefined) &&
        isNotNull(field)
      ? AppColors.Red
      : color;
  const inputFieldColor =
    (required && getWebData.isSubmitted && !isNotNull(field)) ||
    (required &&
      getWebData.isSubmitted &&
      (errorStoreData[name] !== '' || errorStoreData[name] === undefined) &&
      isNotNull(field));
  return (
    <>
      <Styled.InputContainer color={inputColor}>
        <div className={minHeight ? 'textHeight' : ''}>
          {required ? '* ' + label : label}
        </div>
        <Styled.InputField
          $borderColor={inputFieldColor}
          $background={inputFieldColor}
          value={field}
          onChange={(e) => setField(e.target.value)}
          ref={textInput}
          type="text"
          onBlur={(e) => {
            validateForm(
              name,
              type,
              e.target,
              textInput,
              handleTextError,
              required,
              label,
              updateErrorMessage,
              translation
            );
            handleTextInput(name, e.target.value);
          }}
        />
      </Styled.InputContainer>
      <Styled.ErrorContainer>{errorMessage}</Styled.ErrorContainer>
    </>
  );
};
const mapStateToProps = (stateData) => {
  return {
    state: stateData,
  };
};
export default connect(mapStateToProps)(TextField);
